import { compose } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';

import { submittedPayment as adyenSubmittedPayment } from 'ggApp/modules/adyen/selectors';
import { submitPayment, resetSubmittedPaymentError } from 'ggApp/modules/adyen/actions';

import AdyenCardForm from './AdyenCardForm';

const enhance = compose(
    connect(
        createStructuredSelector({
            adyenSubmittedPayment,
        }),
        (dispatch) => ({
            submitPayment: bindActionCreators(submitPayment, dispatch),
            resetSubmittedPaymentError: bindActionCreators(resetSubmittedPaymentError, dispatch),
        }),
    ),
);

export default enhance(AdyenCardForm);
